import { Col, Typography, Layout, Row, List, Button, Image, Dropdown, Menu } from "antd";
import {
  BiLogoLinkedin,
  BiLogoYoutube,
  BiLogoInstagram,
} from "react-icons/bi";
import IconXTwitter from "../icons/IconXTwitter";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Functions";
import { Link } from "react-router-dom";

const { Footer } = Layout;

const ClientFooter = () => {
  const navigate = useNavigate();
  const footerRegisterDrop = (
    <Menu
      items={[
        {
          key: "1",
          label: "Register as Student",
          onClick: () => navigate("/signup"),
        },
        {
          key: "2",
          label: (
            <Link target="_blank" to="https://trainer.wrightcoacademy.com/signup">
              Register as Trainer
            </Link>
          ),
        },
        {
          key: "3",
          label: (
            <Link target="_blank" to="https://wrightcoacademy.com/request">
              Register as Enterprise
            </Link>
          ),
        },
      ]}
    />
  );

  const styles = {
    footer: {
      height: "auto",
      padding: "0",
      background:
        "radial-gradient(circle at top left, #eefbfa 0%, #f9fffe 45%, #ffffff 100%)",
      borderTop: "1px solid rgba(0, 167, 157, 0.16)",
    },
    wrapperRow: {
      justifyContent: "center",
      padding: "14px 12px 4px",
    },
    topSectionCard: {
      borderRadius: "22px",
      border: "1px solid rgba(0, 167, 157, 0.16)",
      background:
        "linear-gradient(165deg, rgba(255,255,255,0.96) 0%, rgba(243,255,253,0.92) 100%)",
      boxShadow: "0 18px 38px rgba(2, 78, 73, 0.1)",
      padding: "16px 8px",
    },
    sectionTitle: {
      color: "#163f3b",
      fontSize: 28,
      marginBottom: 14,
      marginTop: 0,
      fontWeight: 700,
    },
    descriptionText: {
      color: "#4f6664",
      fontSize: 15,
      lineHeight: 1.8,
      display: "block",
    },
    socialIconWrap: {
      width: 42,
      height: 42,
      borderRadius: "50%",
      border: "1px solid rgba(0, 167, 157, 0.24)",
      background: "rgba(0, 167, 157, 0.08)",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      marginRight: 10,
    },
    socialIcon: {
      color: "#145d58",
      fontSize: 21,
    },
    primaryButton: {
      marginTop: "10px",
      padding: "0px 30px",
      cursor: "pointer",
      background: "linear-gradient(120deg, #00a79d 0%, #03716a 100%)",
      color: "white",
      fontWeight: "bold",
      borderRadius: "50px",
      border: "none",
      boxShadow: "0 10px 18px rgba(0, 167, 157, 0.25)",
    },
    secondaryButton: {
      marginTop: "10px",
      padding: "0px 30px",
      background: "#ffffff",
      color: "#0d5d57",
      fontWeight: "bold",
      borderRadius: "50px",
      cursor: "pointer",
      border: "1px solid rgba(0, 167, 157, 0.35)",
    },
    subtitleLink: {
      color: "#1f4f4b",
      fontSize: 17,
      textDecoration: "underline",
      fontWeight: 600,
    },
    footerBottomRow: {
      alignItems: "center",
      justifyContent: "center",
      padding: "16px 12px 24px",
    },
    footerBottomCard: {
      borderRadius: "14px",
      border: "1px solid rgba(0, 167, 157, 0.12)",
      background: "rgba(255, 255, 255, 0.9)",
      padding: "10px 16px",
    },
  };
  return (
    <Footer className="footer" style={styles.footer}>
      <Row
        style={styles.wrapperRow}
      >
        <Col xs={24} md={20}>
          <Row style={styles.topSectionCard}>
            <Col
              xs={24}
              md={10}
              style={{ padding: "30px 0", fontFamily: "Lato" }}
              className={"footer-column"}
            >
              <Row>
                <Col xs={24} md={18}>
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    height={65}
                    // src="/images/logo-header 1.png"
                    src={ImageUrl("logo-footer.png")}
                    style={{ maxWidth: "100%" }}
                    onClick={() => navigate("/")}
                  />
                  <div style={{ padding: "10px 30px 0px 10px" }}>
                    {/* <Typography.Title className="fontFamily1" style={styles.sectionTitle}>
                      About
                    </Typography.Title> */}
                    <Typography.Text
                      className="fontFamily1"
                      style={styles.descriptionText}
                    >
                      We're a passionate group of educators working together to
                      create the best online learning experiences for adult
                      learners like you.
                    </Typography.Text>
                    <br />
                    <br />
                    <div>
                      <span style={styles.socialIconWrap}>
                        <BiLogoLinkedin style={styles.socialIcon} />
                      </span>
                      <span style={styles.socialIconWrap}>
                        <IconXTwitter style={styles.socialIcon} />
                      </span>
                      <span style={styles.socialIconWrap}>
                        <BiLogoYoutube style={styles.socialIcon} />
                      </span>
                      <span style={styles.socialIconWrap}>
                        <BiLogoInstagram style={styles.socialIcon} />
                      </span>
                    </div>
                    <br />
                    <Row>
                      <Dropdown overlay={footerRegisterDrop} trigger={["click"]}>
                        <Button
                          style={styles.primaryButton}
                          size="large"
                        >
                          Register Now
                        </Button>
                      </Dropdown>
                      &emsp;
                      <Button
                        style={styles.secondaryButton}
                        size="large"
                      >
                        Apply Now
                      </Button>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col
              xs={24}
              md={8}
              style={{ padding: "30px 0", fontFamily: "Lato" }}
              className={"footer-column"}
            >
              <div style={{ padding: "10px 30px 0px 10px" }}>
                <Typography.Title className="fontFamily1" style={styles.sectionTitle}>
                  Services
                </Typography.Title>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Typography.Text className="fontFamily1" style={styles.subtitleLink}>
                      <Link
                        to={"https://trainer.wrightcoacademy.com/signin"}
                        style={styles.subtitleLink}
                      >
                        Trainers
                      </Link>
                    </Typography.Text>
                    <List
                      className="footer-list"
                      size="small"
                      style={{ fontSize: 18 }}
                    >
                      <List.Item key="elementary_tutoring" className="footerLink">
                        Head Start
                      </List.Item>
                      <List.Item
                        key="middle_school_tutoring"
                        className="footerLink"
                      >
                        Early Head Start
                      </List.Item>
                      <List.Item key="high_school_tutoring" className="footerLink">
                        Day Care
                      </List.Item>
                      <List.Item key="adult_tutoring" className="footerLink">
                        Family Child Care
                      </List.Item>
                    </List>
                  </Col>
                  <Col xs={24} md={12}>
                    <Typography.Text className="fontFamily1" style={styles.subtitleLink}>
                      <Link
                        to={"https://trainer.wrightcoacademy.com/signin"}
                        style={styles.subtitleLink}
                      >
                        Consulting
                      </Link>
                    </Typography.Text>
                    <List
                      className="footer-list"
                      size="small"
                      style={{ fontSize: 18 }}
                    >
                      <List.Item
                        key="academic_coaching"
                        className="footerLink"
                        onClick={() => navigate("/termsandconditions")}
                      >
                        Terms & Conditions
                      </List.Item>
                      <List.Item
                        key="career_coaching"
                        className="footerLink"
                        onClick={() => navigate("/privacyPolicy")}
                      >
                        Privacy Policy{" "}
                      </List.Item>
                      <List.Item
                        key="mindset_coaching"
                        className="footerLink"
                        onClick={() => navigate("/termsOfService")}
                      >
                        Terms Of Service
                      </List.Item>
                      <List.Item
                        key="conflict_coaching"
                        className="footerLink"
                        onClick={() => navigate("/refundPolicy")}
                      >
                        Refund Policy
                      </List.Item>
                    </List>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col
              xs={24}
              md={6}
              style={{ padding: "30px 0", fontFamily: "Lato" }}
              className={"footer-column"}
            >
              <div style={{ padding: "10px 30px 0px 10px" }}>
                <Typography.Title className="fontFamily1" style={styles.sectionTitle}>
                  Navigation
                </Typography.Title>
                <List
                  className="footer-list"
                  size="small"
                  style={{ fontSize: 18 }}
                >
                  <List.Item
                    key="home"
                    onClick={() => navigate("/")}
                    className="footerLink"
                  >
                    Home
                  </List.Item>
                  <List.Item
                    key="about"
                    onClick={() => navigate("/about-us")}
                    className="footerLink"
                  >
                    About
                  </List.Item>
                  <List.Item
                    key="services"
                    onClick={() => navigate("/courses")}
                    className="footerLink"
                  >
                    Services
                  </List.Item>
                  <List.Item
                    key="book_online"
                    onClick={() => navigate("/pricingPlans")}
                    className="footerLink"
                  >
                    Book Online
                  </List.Item>
                  <List.Item
                    key="disclaimer"
                    onClick={() => navigate("/disclaimer")}
                    className="footerLink"
                  >
                    Disclaimer
                  </List.Item>
                  <List.Item
                    key="copyright"
                    onClick={() => navigate("/copyright")}
                    className="footerLink"
                  >
                    Copyright
                  </List.Item>
                </List>
                <br />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row
        style={styles.footerBottomRow}
      >
        <Col xs={24} md={18}>
          <Row style={styles.footerBottomCard}>
            <Col xs={24} md={14}>
              <p className="footerLink">
                All Rights Reserved WrightCo Academy&trade;.
                {/* Proudly Designed by{" "}
                <a style={{ color: "#333d47", textDecoration: "underline" }}>
                  stategix design
                </a> */}
              </p>
            </Col>
            <Col xs={24} md={10}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                  placeContent: "center",
                }}
              >
                <p
                  className="footerLink"
                  onClick={() => navigate("/termsandconditions")}
                >
                  Terms & Conditions
                </p>
                &emsp;
                <p
                  className="footerLink"
                  onClick={() => navigate("/privacyPolicy")}
                >
                  Privacy Policy
                </p>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Footer>
  );
};

export default ClientFooter;
